type SessionExpiredHandler = () => void;

const requestUsesCurrentSessionToken = (input: RequestInfo | URL, init?: RequestInit) => {
  const token = window.localStorage.getItem('token');
  if (!token) return false;

  const headers = init?.headers ?? (input instanceof Request ? input.headers : undefined);
  const authorization = new Headers(headers).get('authorization');
  return authorization === `Bearer ${token}`;
};

/**
 * Ends the CRM session when the backend rejects its current bearer token.
 * Requests using other credentials (such as service tokens) remain untouched.
 */
export const installSessionExpiryHandler = (onSessionExpired: SessionExpiredHandler) => {
  const nativeFetch = window.fetch.bind(window);
  let sessionExpiryHandled = false;

  window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    const response = await nativeFetch(input, init);

    if (
      response.status === 401 &&
      !sessionExpiryHandled &&
      requestUsesCurrentSessionToken(input, init)
    ) {
      sessionExpiryHandled = true;
      onSessionExpired();
    }

    return response;
  };
};
